import React, { useEffect, useState } from 'react'
import {
    Col,
    Row,
    Form,
    Button,
    Space,
    DatePicker,
    Select,
    type DatePickerProps,
    Tooltip,
} from 'antd'
import commontStyles from './document.less'
import { SaveOutlined } from '@ant-design/icons'
import {
    type PartneshipDataInterFace,
    type PartnershipDocumentSave,
} from '../../../../../../Types/Client/RegisteredClients/Partnership'
import dayjs from 'dayjs'
import { connect, useDispatch } from 'react-redux'
import commonStyles from '../../../../../../Utils/Common.less'
import moment from 'moment'
import ActivePremission from '../../../../../../Utils/premissins'
import { PermissionType } from '../../../../../../Types/Enum/PermissionType'
import S3UploadMultiple from '../../../../../../Components/S3UploadMultiple'
import { SaveOfficerDocument } from '../../../../../../Services/Corporate'
import { GetPartneshipContactInformation } from '../../../../../../Services/Common'
import { type ListFrontEndInterface } from '../../../../../../Types/CommonType'
import { validateDate } from '../../../../../../Utils/ValidateDate'
// import { validateName } from '../../../../../../Utils/Common'

const OfficerDcumentForm = (props: {
    OfficerData: any
    partnershipId: number
    fetchData: () => void
    partneshipContactInfoList: ListFrontEndInterface[]
}): React.ReactElement => {
    const { partnershipId, OfficerData, fetchData, partneshipContactInfoList } =
        props
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const [selectedDatePE, setSelectedDatePE] = useState<string>('')
    const [selectedDateDL, setSelectedDateDL] = useState<string>('')
    const [selectedDatePR, setSelectedDatePR] = useState<string>('')
    const [selectedMemberType, setSelectedMemberType] = useState<number>(0)
    const [selectedDocumentType, setSelectedDocumentType] = useState<number>(24)

    const [showDatePicker, setShowDatePicker] = useState(true)
    const [selectedReferenceId, setSelectedReferenceId] = useState<number>(0)
    const officerDocumentHeaderList =
        OfficerData?.officerDocumentHeaderList ?? []
    useEffect(() => {
        GetPartneshipContactInformation(dispatch, partnershipId)
        form.resetFields()
    }, [partnershipId])
    useEffect(() => {
        if (partneshipContactInfoList.length !== 0) {
            setSelectedMemberType(partneshipContactInfoList?.[0]?.value)
        }
    }, [partneshipContactInfoList])
    const onChangePE = (
        date: DatePickerProps['value'],
        dateString: string | string[]
    ): void => {
        if (date !== null && date !== undefined) {
            const isoDate = date.toISOString()
            setSelectedDatePE(isoDate)
            form.setFieldValue('ppExpiryDate', isoDate)
            void form.validateFields(['ppExpiryDate'])
        }
    }

    const onChangeDL = (
        date: DatePickerProps['value'],
        dateString: string | string[]
    ): void => {
        if (date !== null && date !== undefined) {
            const isoDate = date.toISOString()
            setSelectedDateDL(isoDate)
            form.setFieldValue('dlExpiryDate', isoDate)
            void form.validateFields(['dlExpiryDate'])
        }
    }

    const onChangePR = (
        date: DatePickerProps['value'],
        dateString: string | string[]
    ): void => {
        if (date !== null && date !== undefined) {
            const isoDate = date.toISOString()
            setSelectedDatePR(isoDate)
            form.setFieldValue('prExpiryDate', isoDate)
            void form.validateFields(['prExpiryDate'])
        }
    }

    const handleDoumentTypeChange = (value: number): void => {
        setSelectedDocumentType(value)
        setShowDatePicker(value === 24)
        form.resetFields(['attachmentPath'])
    }

    const handleMemberTypeChange = (value: number): void => {
        if (value !== 0) {
            setSelectedMemberType(value)
            setSelectedReferenceId(0)
            form.resetFields(['attachmentPath'])
        }
    }
    useEffect(() => {
        form.setFieldValue('ppExpiryDate', selectedDatePE)
        form.setFieldValue('dlExpiryDate', selectedDateDL)
        form.setFieldValue('prExpiryDate', selectedDatePR)
    }, [selectedDatePE, selectedDateDL, selectedDatePR])

    const findCompanyAttachmentId = (
        officerDocumentHeaderList: any,
        selectedReferenceId: number,
        selectedDocumentType: number
    ): number => {
        if (!Array.isArray(officerDocumentHeaderList)) {
            console.warn(
                'Invalid officerDocumentHeaderList:',
                officerDocumentHeaderList
            )
            return 0
        }

        for (const header of officerDocumentHeaderList) {
            if (header.officerPersonOrCorporateId === selectedReferenceId) {
                const matchingDocument = header?.officerDocumentList?.find(
                    (document: any) =>
                        document.documentBaseId === selectedDocumentType
                )

                return matchingDocument?.companyAttachmentId ?? 0
            }
        }

        return 0
    }

    const handelSave = (): void => {
        void handelDataSave()
    }
    const handelDataSave = async (): Promise<void> => {
        try {
            await form.validateFields()
            const formdata = form.getFieldsValue()
            // const membertype: string = selectedMemberType === 'PERSON'

            const documentname =
                selectedDocumentType === 4 ? 'ID Proof' : 'Address Proof'

            const companyAttachmentId = findCompanyAttachmentId(
                officerDocumentHeaderList,
                selectedReferenceId,
                selectedDocumentType
            )
            const ppExpiryDate =
                formdata.ppExpiryDate != null
                    ? moment(formdata.ppExpiryDate).format('DD/MM/YYYY')
                    : ''

            const dlExpiryDate =
                formdata.dlExpiryDate != null
                    ? moment(formdata.dlExpiryDate).format('DD/MM/YYYY')
                    : ''

            const prExpiryDate =
                formdata.prExpiryDate != null
                    ? moment(formdata.prExpiryDate).format('DD/MM/YYYY')
                    : ''
            const convertedString = uploadFileList
                .map((item) => item.slice())
                .join(', ')
            const savedata = {
                companyAttachmentId: companyAttachmentId ?? 0,
                companyTypeId: 4,
                referenceId: selectedReferenceId,
                referenceId2: 0,
                documentBaseId: selectedDocumentType ?? 0,
                documentBaseName: documentname,
                attachmentPath: convertedString ?? '',
                corporateId: 0,
                type: '',
                ppExpiryDate:
                    ppExpiryDate !== 'Invalid date' ? ppExpiryDate : '',
                dlExpiryDate:
                    dlExpiryDate !== 'Invalid date' ? dlExpiryDate : '',
                prExpiryDate:
                    prExpiryDate !== 'Invalid date' ? prExpiryDate : '',
            }
            await SaveOfficerDocument(dispatch, savedata).then((result) => {
                if (result !== null && result !== undefined) {
                    fetchData()

                    form.resetFields(['attachmentPath'])
                }
            })
        } catch (error) {}
    }

    const [uploadFileList, setUploadFileList] = useState<string[]>([])

    const handleSetFormData = (name: string, locations: string[]): void => {
        setUploadFileList(locations)
        form.setFieldValue('attachmentPath', locations)
        void form.validateFields(['attachmentPath'])
    }
    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commonStyles.requireIcon}>*</span>}
        </>
    )
    return (
        <div className={commontStyles.formWrapper}>
            <Form
                name="complex-form 333"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
                layout={'vertical'}
                autoComplete="off"
                form={form}
                requiredMark={customizeRequiredMark}
            >
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item<PartnershipDocumentSave>
                            label="Member Partner"
                            name="memberPartner"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Enter Member Partner',
                                },
                                // {
                                //     validator: async (rule, value) =>
                                //         await validateName(
                                //             rule,
                                //             value,
                                //             'Member Partner'
                                //         ),
                                // },
                            ]}
                        >
                            <Select
                                allowClear
                                placeholder="Please select"
                                onChange={handleMemberTypeChange}
                                value={selectedMemberType}
                                showSearch
                                filterOption={(input, option) =>
                                    option?.label
                                        ?.toLowerCase()
                                        .includes(input.toLowerCase()) ?? false
                                }
                                options={partneshipContactInfoList}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item<PartnershipDocumentSave>
                            label="Document Type"
                            name="documentBaseId"
                            className={`${
                                selectedDocumentType === 25
                                    ? commontStyles.CorporteDocumentGeenreal
                                    : ''
                            }`}
                        >
                            <Select
                                allowClear
                                placeholder="Please select"
                                onChange={handleDoumentTypeChange}
                                value={selectedDocumentType}
                                defaultValue={24}
                            >
                                <Select.Option value={25}>
                                    Address Proof
                                </Select.Option>
                                <Select.Option value={24}>
                                    ID Proof
                                </Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                {showDatePicker && (
                    <>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item<PartnershipDocumentSave>
                                    label="Passport Expiry Date"
                                    name="ppExpiryDate"
                                    rules={[
                                        {
                                            validator: async (_, value) =>
                                                await validateDate(value),
                                        },
                                    ]}
                                >
                                    <Space direction="vertical" size={12}>
                                        <DatePicker
                                            format={'DD/MM/YYYY'}
                                            onChange={(date, dateString) => {
                                                onChangePE(date, dateString)
                                            }}
                                            value={
                                                selectedDatePE.length > 0
                                                    ? dayjs(selectedDatePE)
                                                    : undefined
                                            }
                                            className={commontStyles.dateWidth}
                                            allowClear
                                            disabledDate={(current) =>
                                                current != null &&
                                                current.isBefore(
                                                    dayjs().startOf('day')
                                                )
                                            }
                                        />
                                    </Space>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item<PartnershipDocumentSave>
                                    label="Driving Licence Expiry Date"
                                    name="dlExpiryDate"
                                    rules={[
                                        {
                                            validator: async (_, value) =>
                                                await validateDate(value),
                                        },
                                    ]}
                                >
                                    <Space direction="vertical" size={12}>
                                        <DatePicker
                                            format={'DD/MM/YYYY'}
                                            onChange={(date, dateString) => {
                                                onChangeDL(date, dateString)
                                            }}
                                            value={
                                                selectedDateDL.length > 0
                                                    ? dayjs(selectedDateDL)
                                                    : undefined
                                            }
                                            className={commontStyles.dateWidth}
                                            allowClear
                                            disabledDate={(current) =>
                                                current != null &&
                                                current.isBefore(
                                                    dayjs().startOf('day')
                                                )
                                            }
                                        />
                                    </Space>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item<PartnershipDocumentSave>
                                    label="PR Expiry Date"
                                    name="prExpiryDate"
                                    rules={[
                                        {
                                            validator: async (_, value) =>
                                                await validateDate(value),
                                        },
                                    ]}
                                >
                                    <Space direction="vertical" size={12}>
                                        <DatePicker
                                            onChange={(date, dateString) => {
                                                onChangePR(date, dateString)
                                            }}
                                            className={commontStyles.dateWidth}
                                            value={
                                                selectedDatePR.length > 0
                                                    ? dayjs(selectedDatePR)
                                                    : null
                                            }
                                            format={'DD/MM/YYYY'}
                                            allowClear
                                            disabledDate={(current) =>
                                                current != null &&
                                                current.isBefore(
                                                    dayjs().startOf('day')
                                                )
                                            }
                                        />
                                    </Space>
                                </Form.Item>
                            </Col>
                        </Row>
                    </>
                )}

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="attachmentPath"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Attach Attachments!',
                                },
                            ]}
                        >
                            <S3UploadMultiple
                                name={'attachmentPath'}
                                value={uploadFileList}
                                setFormData={handleSetFormData}
                                corporate={'Partnership'}
                                corporateid={partnershipId}
                                documenttype={''}
                                documentbaseId={selectedDocumentType}
                                memberpersonId={selectedReferenceId}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                {ActivePremission('3000', PermissionType.SAVE) && (
                    <Row
                        gutter={16}
                        className={commontStyles.CorporteDocument}
                        style={{ marginTop: 50 }}
                    >
                        <Col offset={20} span={2}>
                            <Tooltip title="Save Document">
                                <Button type="primary" onClick={handelSave}>
                                    <SaveOutlined />
                                </Button>
                            </Tooltip>
                        </Col>
                    </Row>
                )}
            </Form>
        </div>
    )
}

const mapStateToProps = (state: any): PartneshipDataInterFace => {
    return {
        partneshipContactInfoList: state.common.partneshipContactInfoList,
    }
}

export default connect(mapStateToProps)(OfficerDcumentForm)
